export default "__VITE_ASSET__3Aiw6Zod__"